/**
 * The pathname, search, and hash values of a URL.
 */

/**
 * Describes a location that is the destination of some navigation, either via
 * `history.push` or `history.replace`. May be either a URL or the pieces of a
 * URL path.
 */

/**
 * @private
 */

export function invariant(value, message) {
  if (value === false || value === null || typeof value === 'undefined') {
    if (typeof console !== 'undefined') {
      console.error(message);
    }
  }
}
export function warning(cond, message) {
  if (!cond) {
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // Welcome to debugging history!
      //
      // This error is thrown as a convenience so you can more easily
      // find the source for a warning that appears in the console by
      // enabling "pause on exceptions" in your JavaScript debugger.
      throw new Error(message);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }
}